import { Pipe, PipeTransform } from '@angular/core';
import { TxDocument } from '../model/document.model';
import { SigningState } from '../model/signing-state.model';

@Pipe({
  name: 'isDocSignedByClient',
})
export class IsDocSignedByClientPipe implements PipeTransform {
  transform(document: TxDocument, clientId: string): boolean {
    const signer = document.getSignerById(clientId);
    return signer.signingState === SigningState.Finished;
  }
}
